<div class="eu-flex loader-position">
  <div class="eu-basis_12 eu-basis_10_md eu-offset_1_md">
    <div
      class="eu-basis_12 eu-basis_2_md eu-offset_5_md emd-text _align_center _type_hint _color_primary"
      [ngClass]="[colorClass]"
    >
      <div
        class="spinner-border"
        [style]="style"
        [ngStyle]="{ 'font-size': resolution }"
        [ngClass]="ngClass"
      ></div>
      <h2 class="emd-text _size_page" *ngIf="showMessage">{{ message }}</h2>
    </div>
  </div>
</div>
